import React from 'react';
import { FlatList } from 'react-native-gesture-handler';
import { OrganizationCard, CardItem } from '../list-items/CardItem'; 
import { Card, Text } from '../_primatives';
import { Platform } from 'react-native';


const HEADER_TOP_MARGIN: number = Platform.OS === 'web' ? 0 : -2;


export const OrgList = ({ data, navigation, pageSpacerHorizontal, user_org_id, highlightColor }: OrgListProps) => {
    const renderHeader = (): React.ReactElement => (
        <Card style={{ marginTop: HEADER_TOP_MARGIN }}>
            <Text category='h1'>{'Groups'}</Text>
            <Text category='p1'>You have {`${data.organizations.length} group${data.organizations.length === 1 ? '' : 's'}`}</Text>

            {/* <Layout style={{ flexDirection: 'row', justifyContent: 'space-between', flexWrap: 'wrap', paddingTop: 12 }}>
                <Button
                    onPress={() => navigation.navigate('CreateGroup')}
                    status='basic'
                    icon={(style) => <Icon {...style} name='plus-circle-outline' />}
                >
                    {`Create Group`}
                </Button>
            </Layout> */}
        </Card>
    );
    const renderFooter = (): React.ReactElement => (
        <Card>
            <Text category='p1'>{'\n'}</Text>
        </Card>
    );
    const renderOrganization = ({ item }) => (
        <OrganizationCard
            item={item}
            onPress={() => navigation.navigate('Group', { group_id: item.id })}
            style={(user_org_id && user_org_id === item.id) ? { borderLeftWidth: 4, borderLeftColor: highlightColor || 'gray' } : {}}
            // style={[{ marginRight: 10 }]}
        />
    );
    const keyExtractor = (item: CardItem) => item.id;


    return (
        <FlatList
            data={data.organizations}
            renderItem={renderOrganization}
            style={{ flex: 1, padding: pageSpacerHorizontal }}
            keyExtractor={keyExtractor}
            ListHeaderComponent={renderHeader}
            ListFooterComponent={renderFooter}
        />
    );
}


export interface OrgListProps {
    data: any;
    navigation: any;
    pageSpacerHorizontal: number;
    user_org_id?: any;
    highlightColor?: string;
}